import React, { useEffect, useState } from 'react';
import './styles';
import { useSelector } from 'react-redux';
import { USER_ROLE_AGENT } from '../../../../utils/Config/Constants';
import UIMenuBody, { filterSelectedItem } from '../../../../components/UI/UIMenuBody';
import {
	TECHNICIAN_ADMIN_TAB,
	TECHNICIAN_CERTIFICATES_TAB,
	TECHNICIAN_INFO_TAB,
	TECHNICIAN_LISTINGS_TAB,
	TECHNICIAN_PROMOTIONS_TAB,
	TECHNICIAN_SERVICE_AREA_TAB,
	TECHNICIAN_SERVICE_HISTORY_TAB
} from '../../../../utils/Config/MenuBodyTabs';
import Helmet from 'react-helmet';
import UIBookingButton from '../../../../components/UI/UIBookingButton';
import IndividualTechnicianCertificates from './IndividualTechnicianCertificates';
import IndividualTechnicianInfo from './IndividualTechnicianInfo';
import IndividualTechnicianPromos from './IndividualTechnicianPromos';
import IndividualTechnicianNetworkServices from './IndividualTechnicianNetworkServices';
import IndividualTechnicianServiceArea from './IndividualTechnicianServiceArea';
import IndividualTechnicianAdmin from './IndividualTechnicianAdmin';
import IndividualTechnicianListings from './IndividualTechnicianListings';
import { getSignedInUserRoleSelector } from '../../../../redux/selectors/CurrentUserSelectors';
import { useLocation, useRouteMatch } from 'react-router-dom';
import { useLazyQuery } from '@apollo/react-hooks';
import { GET_TECHNICIAN_INFO } from './IndividualTechnicianInfo/queries';

export default function IndividualTechnician({}: IndividualTechnicianProps) {
	const [technician, setTechnician] = useState<UserType>();
	const userRole = useSelector(getSignedInUserRoleSelector);

	const location = useLocation();
	const match = useRouteMatch();

	const [getTechnician, { data: technicianData }] = useLazyQuery(GET_TECHNICIAN_INFO, {
		variables: { id: match.params['id'] }
	});

	useEffect(() => {
		(async () => {
			await getTechnician();
		})();
	}, []);

	useEffect(() => {
		(() => {
			if (technicianData) {
				const fetchedTechnician: UserType = technicianData['user'];
				setTechnician(fetchedTechnician);
			}
		})();
	}, [technicianData]);

	if (!technician) return null;

	const getTabs = () => {
		return [
			TECHNICIAN_INFO_TAB,
			TECHNICIAN_CERTIFICATES_TAB,
			TECHNICIAN_PROMOTIONS_TAB,
			TECHNICIAN_SERVICE_HISTORY_TAB,
			TECHNICIAN_LISTINGS_TAB,
			TECHNICIAN_SERVICE_AREA_TAB,
			TECHNICIAN_ADMIN_TAB
		];
	};

	const renderSelectedPage = () => {
		const technicianId = match.params['id'];

		const selectedPage = filterSelectedItem(getTabs(), location);

		switch (selectedPage) {
			case TECHNICIAN_INFO_TAB:
				return <IndividualTechnicianInfo technicianId={technicianId} />;
			case TECHNICIAN_CERTIFICATES_TAB:
				return <IndividualTechnicianCertificates technicianId={technicianId} />;
			case TECHNICIAN_PROMOTIONS_TAB:
				return <IndividualTechnicianPromos technicianId={technicianId} />;
			case TECHNICIAN_SERVICE_HISTORY_TAB:
				return <IndividualTechnicianNetworkServices technicianId={technicianId} />;
			case TECHNICIAN_LISTINGS_TAB:
				return <IndividualTechnicianListings technicianId={technicianId} />;
			case TECHNICIAN_SERVICE_AREA_TAB:
				return <IndividualTechnicianServiceArea technicianId={technicianId} />;
			case TECHNICIAN_ADMIN_TAB:
				return <IndividualTechnicianAdmin technicianId={technicianId} />;
			default:
				return null;
		}
	};

	if (userRole === USER_ROLE_AGENT) {
		return <div />;
	}

	return (
		<UIMenuBody
			menuTitle={technician.name}
			menuHeader={
				<div className='individualTechnician__menu-header'>
					<p className='individualTechnician__menu-header--name'>{technician.name}</p>
					<div className='pl-separator' />
					<UIBookingButton bookingClient={technician} />
					<div className='pl-separator' />
				</div>
			}
			menuItems={getTabs()}>
			<>
				<Helmet>
					<title>{technician.name || 'Technician'} | Pineapple Labs</title>
					<meta property='og:title' content={`${technician.name || 'Technician'} | Pineapple Labs`} />
				</Helmet>
				{renderSelectedPage()}
			</>
		</UIMenuBody>
	);
}
